<div class="">
  <ng-template libCustomHost></ng-template>
</div>

<div *ngIf="!currentAssortment || !breadcrumbMenu || !type" class="px-5">LOADING...</div>